namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonSumBillRow {
        Id?: string;
        RefundId?: number;
        RefundReason?: string;
        BillQty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        VatOfCharge?: number;
        AllItemCharge?: number;
        DtList?: ReportRefundReasonSumBillDtRow[];
    }

    export namespace ReportRefundReasonSumBillRow {
        export const idProperty = 'RefundId';
        export const nameProperty = 'RefundReason';
        export const localTextPrefix = 'RefundReasonReport.ReportRefundReasonSumBill';
        export const lookupKey = 'RefundReasonReport.ReportRefundReasonSumBill';

        export function getLookup(): Q.Lookup<ReportRefundReasonSumBillRow> {
            return Q.getLookup<ReportRefundReasonSumBillRow>('RefundReasonReport.ReportRefundReasonSumBill');
        }
        export const deletePermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรวมบิล:View';
        export const insertPermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรวมบิล:View';
        export const readPermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรวมบิล:View';
        export const updatePermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรวมบิล:View';

        export declare const enum Fields {
            Id = "Id",
            RefundId = "RefundId",
            RefundReason = "RefundReason",
            BillQty = "BillQty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            VatOfCharge = "VatOfCharge",
            AllItemCharge = "AllItemCharge",
            DtList = "DtList"
        }
    }
}
